module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center row"
  }, [(_vm.pager) ? _c('ul', {
    staticClass: "pagination ",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [(_vm.pager.current > 1) ? _c('li', {
    staticClass: "footable-page-arrow"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickPager(1)
      }
    }
  }, [_vm._v("«")])]) : _vm._e(), _vm._v(" "), (_vm.pager.current > 1) ? _c('li', {
    staticClass: "footable-page-arrow"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clickPager(Number(_vm.pager.current) - 1)
      }
    }
  }, [_vm._v("‹")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pager.children), function(page) {
    return [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (page == _vm.pager.current),
        expression: "page == pager.current"
      }],
      staticClass: "footable-page active"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.clickPager(page)
        }
      }
    }, [_vm._v(_vm._s(page))])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (page != _vm.pager.current),
        expression: "page != pager.current"
      }],
      staticClass: "footable-page"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.clickPager(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])]
  }), _vm._v(" "), (_vm.pager.current < _vm.pager.last) ? _c('li', {
    staticClass: "footable-page-arrow"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clickPager(Number(_vm.pager.current) + 1)
      }
    }
  }, [_vm._v("›")])]) : _vm._e(), _vm._v(" "), (_vm.pager.current < _vm.pager.last) ? _c('li', {
    staticClass: "footable-page-arrow"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickPager(_vm.pager.last)
      }
    }
  }, [_vm._v("»")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('small', [_vm._v("View " + _vm._s(_vm.pager.view) + " of " + _vm._s(_vm.pager.count))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1badf771"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pager.vue
// module id = 437
// module chunks = 1